import { instrumentBundleByDefinitionId, instrumentCatalog } from "../instruments/catalog";
import type { Cable, PatchDocument } from "./patch";

export const GRANDMOTHER_NODE_ID = "instrument-grandmother-1";

const initialCables: Cable[] = [
  {
    id: "cable-1",
    number: 1,
    colour: "#ef6b55",
    endpointA: { kind: "port", nodeId: GRANDMOTHER_NODE_ID, portId: "mod-wave-out" },
    endpointB: { kind: "port", nodeId: GRANDMOTHER_NODE_ID, portId: "filter-cutoff-in" },
  },
  {
    id: "cable-2",
    number: 2,
    colour: "#6ee672",
    endpointA: { kind: "port", nodeId: GRANDMOTHER_NODE_ID, portId: "env-positive-out" },
    endpointB: { kind: "port", nodeId: GRANDMOTHER_NODE_ID, portId: "osc1-pitch-in" },
  },
  {
    id: "cable-3",
    number: 3,
    colour: "#60a8df",
    endpointA: { kind: "port", nodeId: GRANDMOTHER_NODE_ID, portId: "osc2-wave-out" },
    endpointB: { kind: "loose", x: 585, y: 455, label: "Performance lead" },
  },
];

function newId() {
  return globalThis.crypto?.randomUUID?.() ?? `patch-${Date.now()}`;
}

export function createInitialPatchDocument(
  options: { definitionId?: string; id?: string; now?: string; title?: string } = {},
): PatchDocument {
  const now = options.now ?? new Date().toISOString();
  const instrument =
    instrumentBundleByDefinitionId(options.definitionId)?.document ??
    instrumentCatalog[0]!.document;
  const isGrandmother = instrument.id === instrumentCatalog[0]!.document.id;
  return {
    schemaVersion: 1,
    id: options.id ?? newId(),
    title: options.title ?? "Dream Sequence",
    createdAt: now,
    updatedAt: now,
    author: "Pirate Beer",
    revision: { number: 1, label: "Working copy" },
    workspace: {
      nodes: [
        {
          kind: "instrument",
          id: GRANDMOTHER_NODE_ID,
          definitionId: instrument.id,
          displayName: instrument.metadata.displayName,
          position: { x: 0, y: 0 },
          scale: 1,
          controlValues: {},
          rearPanelVisible: true,
        },
      ],
      cableAssemblies: isGrandmother ? structuredClone(initialCables) : [],
      annotations: [],
    },
    metadata: {
      category: isGrandmother ? "Sequence" : "Patch",
      tags: isGrandmother ? ["ambient", "dreamy", "evolving"] : [],
      favourite: isGrandmother,
      description: isGrandmother
        ? "Slow evolving sequence with a modulated filter and a long spring-reverb tail. Uses the arpeggiator in random order."
        : "",
      tempo: 120,
    },
    notes: { body: "" },
    customSettings: [],
    attachments: [],
    performanceStates: [],
    printSettings: {
      diagramStyle: "wireframe",
      palette: "monochrome",
      paper: "a4",
      orientation: "landscape",
      cableIdentification: "number-and-pattern",
    },
  };
}
